import { quoteModelRevisionWithHoles_quoteModelRevision as quoteModelRevisionWithHoles } from '@Builder/QuoteDetailPage/FilesTab/ConfigurationModal/__generated__/quoteModelRevisionWithHoles'
import { WebViewerInstance, Annotations } from '@pdftron/webviewer'
import { Error } from 'aws-sdk/clients/s3'
import {
    THREADS_KEY,
    CONFIGURATION_KEY,
    ADDITIONAL_REQ_KEY,
    DFM_FEEDBACK_KEY,
    DRAWING_ANALYSIS_KEY,
} from '@Builder/QuoteDetailPage/FilesTab/ConfigurationModal/constants'

import {
    QuoteDetails_QuoteFragment as Quote,
    QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevisionFragment as QuoteModelRevisions,
    QmrDfmFeedback_QuoteModelRevisionFragment as qmrDfmFeedBackquoteModelRevision,
    AdditionalRequirementsRawPdfOcrDataFragment as RawPdfOcrJson,
} from '~/gql/graphql'
import { getByQuoteModelRevisionAttachmentId_getModelAttachmentOcrData as ModelAttachmentOcrData } from '~/redux-modules/dfm-layers/__generated__/getByQuoteModelRevisionAttachmentId'

import {
    setTechnicalDrawingSectionType,
    setTechnicalDrawingAlertType,
    setSelectedQuoteModelRevisions,
    setLoadingDataForAttachment,
    setUploadLoadingDataForAttachment,
    setAnalyzingDataForAttachment,
    setPDFOCRData,
    setWebviewerInstance,
    setPDFOCRDataFailure,
    setQuote,
    setSelectedTabForModal,
    showDrawingButtonOnInspectionModal,
    clearPDFOCR,
    setGeneratedDrawingForAttachment,
    setQmrHoleDetails,
    setQmrDFMFeedbackRevision,
    setEditPdfMode,
    setqmrAttachmentAnnotationsResponse,
    setShowLoading,
    setErrorMessage,
    setShowRFQModal,
    setUnsavedAnno,
    setPdfInfoUserName,
    setObfuscateFictivAnnotationAttribution,
    setPdfUrl,
    setTechnicalSectionBackgroudColorForWarning,
    setAddtionalRequirementsRawPDFOCRData,
    setAdditionalRequirementsRawPDFOCRDataFailure,
} from './actions'

export enum TechnicalDrawingSectionType {
    info = 'info',
    success = 'success',
}

export enum TechnicalDrawingAlertType {
    info = 'info-circle',
    success = 'check-circle',
}

export enum LoadingData {
    show = 1,
    hide = 0,
}

export enum GeneratedDrawing {
    show = 1,
    hide = 0,
}

export enum UploadLoadingData {
    show = 1,
    hide = 0,
}

export enum AnalyzingData {
    show = 1,
    hide = 0,
}

export enum ShowDrawingButton {
    show = 1,
    hide = 0,
}

export type SelectedTabValue =
    | typeof CONFIGURATION_KEY
    | typeof ADDITIONAL_REQ_KEY
    | typeof DFM_FEEDBACK_KEY
    | typeof THREADS_KEY
    | typeof DRAWING_ANALYSIS_KEY

// union type made from all return types of all actions, used to appease TS compiler in the reducer
export type DFMLayersActionType =
    | ReturnType<typeof setTechnicalDrawingSectionType>
    | ReturnType<typeof setTechnicalDrawingAlertType>
    | ReturnType<typeof setSelectedQuoteModelRevisions>
    | ReturnType<typeof setLoadingDataForAttachment>
    | ReturnType<typeof setUploadLoadingDataForAttachment>
    | ReturnType<typeof setAnalyzingDataForAttachment>
    | ReturnType<typeof setPDFOCRData>
    | ReturnType<typeof clearPDFOCR>
    | ReturnType<typeof setWebviewerInstance>
    | ReturnType<typeof setPDFOCRDataFailure>
    | ReturnType<typeof setQuote>
    | ReturnType<typeof setSelectedTabForModal>
    | ReturnType<typeof showDrawingButtonOnInspectionModal>
    | ReturnType<typeof setGeneratedDrawingForAttachment>
    | ReturnType<typeof setQmrHoleDetails>
    | ReturnType<typeof setQmrDFMFeedbackRevision>
    | ReturnType<typeof setEditPdfMode>
    | ReturnType<typeof setqmrAttachmentAnnotationsResponse>
    | ReturnType<typeof setShowLoading>
    | ReturnType<typeof setErrorMessage>
    | ReturnType<typeof setShowRFQModal>
    | ReturnType<typeof setUnsavedAnno>
    | ReturnType<typeof setPdfInfoUserName>
    | ReturnType<typeof setObfuscateFictivAnnotationAttribution>
    | ReturnType<typeof setPdfUrl>
    | ReturnType<typeof setTechnicalSectionBackgroudColorForWarning>
    | ReturnType<typeof setAddtionalRequirementsRawPDFOCRData>
    | ReturnType<typeof setAdditionalRequirementsRawPDFOCRDataFailure>

export type INITIAL_STATE_TYPE = {
    technicalDrawingSectionType: TechnicalDrawingSectionType
    technicalDrawingAlertType: TechnicalDrawingAlertType
    selectedQuoteModelRevisions: [QuoteModelRevisions] | []
    attachingloading: LoadingData
    uploadingData: UploadLoadingData
    analyzingData: AnalyzingData
    showDrawingButton: ShowDrawingButton
    PDFOCRData: ModelAttachmentOcrData | null
    PDFOCRError: Error | null
    webviewerInstance: WebViewerInstance | null
    quote: Quote | null
    selectedTabName: SelectedTabValue | null
    generatedDrawing: GeneratedDrawing
    qmrWithHolesDetail: quoteModelRevisionWithHoles | null
    qmrWithDfmFeedBack: qmrDfmFeedBackquoteModelRevision | null
    editPdfMode: boolean
    qmrAttachmentAnnotations: any
    showLoading: boolean
    errorMessage: boolean
    showRFQModal: boolean
    unsavedAnno: Annotations.Annotation[]
    userName: string
    obfuscateFictivAnnotationAttribution: boolean
    pdfUrl: string | null
    backgroudWarningColor: any
    RAWPDFOCRError: Error | null
    RAWPDFOCRData: RawPdfOcrJson | null
}
